import { Component, Input, Output, EventEmitter } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faComments, faTimes, faCheck, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { InteractionsService } from '../../services/interactions.service';
import { RetrieversService } from '../../services/retrievers.service';
import { ProcessingsService } from '../../services/processings.service';

@Component({
  selector: 'app-modal-create-interaction',
  standalone: true,
  imports: [FormsModule, FontAwesomeModule, TranslateModule],
  templateUrl: './modal-create-interaction.component.html',
  styleUrls: ['./modal-create-interaction.component.scss']
})
export class ModalCreateInteractionComponent {
  @Input() show = false;
  @Output() close = new EventEmitter<void>();
  @Output() created = new EventEmitter<void>();

  faComments = faComments;
  faTimes = faTimes;
  faCheck = faCheck;
  faChartLine = faChartLine;

  name = '';
  simulationType: 'extraction' | 'classification' | 'retriever' | 'processing' = 'extraction';
  simulationTypes = [
    { value: 'extraction', labelKey: 'SIMULATIONS.TYPE.EXTRACTION' },
    { value: 'classification', labelKey: 'SIMULATIONS.TYPE.CLASSIFICATION' },
    { value: 'retriever', labelKey: 'SIMULATIONS.TYPE.RETRIEVER' },
    { value: 'processing', labelKey: 'SIMULATIONS.TYPE.PROCESSING' },
  ];
  loading = false;
  error = '';

  constructor(
    private interactionsService: InteractionsService,
    private retrieversService: RetrieversService,
    private processingsService: ProcessingsService,
  ) {}

  onClose() {
    this.close.emit();
    this.reset();
  }

  onCreate() {
    if (!this.name.trim()) {
      this.error = 'INTERACTIONS.NAME_REQUIRED';
      return;
    }

    this.loading = true;
    this.error = '';
    const name = this.name.trim();
    const createRequest: Observable<unknown> = this.simulationType === 'retriever'
      ? this.retrieversService.create({
          name,
          content: '',
          instructions: '',
          extraction_default_value: '',
          overwrite_cache: true,
          user_list: [],
          llm_model: 'M1.2',
          knowledge: '',
          retriever: 'RE1.1',
          top_k: 20,
          search_columns: [],
          delfos_server_config_id: null,
        })
      : this.simulationType === 'processing'
        ? this.processingsService.create({
            name,
            input_archive_ids: [],
            operations: [],
            delfos_server_config_id: null,
            llm_model: null,
            model_id: null,
          })
        : this.interactionsService.create(name, this.simulationType);

    createRequest.subscribe({
      next: () => {
        this.created.emit();
        this.onClose();
      },
      error: () => {
        this.error = 'INTERACTIONS.CREATE_ERROR';
        this.loading = false;
      }
    });
  }

  reset() {
    this.name = '';
    this.simulationType = 'extraction';
    this.loading = false;
    this.error = '';
  }
}